import React, { useState, useEffect } from 'react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { useToast } from '../../components/ui/use-toast';
import { api } from '../../services/api';

const AdminSettings = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const { toast } = useToast();

  const [settings, setSettings] = useState({
    shipping: {
      flat_rate: 10,
      free_shipping_threshold: null
    }
  });

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const data = await api.getSettings();
      setSettings(data);
    } catch (error) {
      console.error('Failed to load settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      await api.updateSettings(settings);
      toast({
        title: 'Success',
        description: 'Settings updated successfully'
      });
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Failed to update settings',
        variant: 'destructive'
      });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Settings</h1>

      <Card className="p-6">
        <h2 className="text-lg font-medium mb-4">Shipping Configuration</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label>Flat Shipping Rate ($) *</Label>
            <Input
              type="number"
              step="0.01"
              value={settings.shipping.flat_rate}
              onChange={(e) =>
                setSettings({
                  ...settings,
                  shipping: { ...settings.shipping, flat_rate: parseFloat(e.target.value) || 0 }
                })
              }
              placeholder="10.00"
              required
            />
            <p className="text-sm text-gray-500 mt-1">
              This amount will be added to all orders.
            </p>
          </div>

          <div>
            <Label>Free Shipping Threshold ($)</Label>
            <Input
              type="number"
              step="0.01"
              value={settings.shipping.free_shipping_threshold || ''}
              onChange={(e) =>
                setSettings({
                  ...settings,
                  shipping: {
                    ...settings.shipping,
                    free_shipping_threshold: e.target.value ? parseFloat(e.target.value) : null
                  }
                })
              }
              placeholder="Leave empty for no free shipping"
            />
            <p className="text-sm text-gray-500 mt-1">
              Orders above this amount will have free shipping. Leave empty to disable.
            </p>
          </div>

          <Button type="submit" disabled={saving}>
            {saving ? 'Saving...' : 'Save Settings'}
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default AdminSettings;
